import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayModule } from "@angular/cdk/overlay";
import { DsBannerComponent } from "./ds-banner.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsBannerComponent],
  imports: [CommonModule, OverlayModule, DsIconModule],
  exports: [DsBannerComponent],
})
export class DsBannerModule {}
